angular.module('clients.finder', ['clients', 'lead'])
    .factory('ClientLead', function ($resource) {
        return $resource('/crm/api/client-lead/:id', {id: '@id'}, {
            // list: {method: 'GET', isArray: false},
            get: {method: 'GET'},
            update: {method: 'PUT'},
            autocomplete: {method: 'GET', isArray: true, url: '/crm/api/client-lead/autocomplete'},
            suggest: {method: 'POST', isArray: true, url: '/crm/api/client-lead/suggest'},
        });
    })
    .service('ClientFinderService', function (modals) {
        this.edit = (client, options) => {
            options = options || {}
            return modals.open('app/clients/client-finder/edit.html', 'ClientFinderDialogController', {client: client, options: options}, {size: options.modalSize || 'md'}, "$ctrl")
        }
        this.preview = client => modals.open('app/clients/client-finder/compact-preview-modal.html', 'ClientFinderPreviewController', client, {size: 'md'}, "$ctrl")
    })
    .component('clientFinder', {
        bindings: {
            client: '<',
            editable: '<',
            allClients: '<',
            onSelect: "&",
            template: '<',
            options: '<',
            restrictedSearch: '<',
            allowCreateWithoutSearch: '<',
        },
        templateUrl: "app/clients/client-finder/finder.html",
        controller: function (modals, $state, ClientLead, Client, ClientService, ClientFinderService, Principal) {
            const defaultOptions = {
                showManager: true,
                showEmail: true,
                showPhone: true,
                showName: true,
            };
            this.selectedContacts = [];
            this.selectedManagers = [];

            this.$onInit = () => {
                this.options = angular.extend({}, defaultOptions, this.options);
                this.canOpenClientModule = Principal.hasAnyAuthority(['ROLE_CLIENTS']);
                this.canReadClients = Principal.hasAnyAuthority(['ROLE_CLIENTS_READ']);
                this.canWriteClients = Principal.hasAnyAuthority(['ROLE_CLIENTS_WRITE']);
                this.canSearchRegisteredClients = Principal.hasAnyAuthority(['ROLE_CLIENTS_SEARCH']);
                this.canReadLeadClients = this.canReadClients || Principal.hasAnyAuthority(['ROLE_CLIENTS_LEAD_READ']);
                this.canWriteLeadClients = this.canWriteClients || Principal.hasAnyAuthority(['ROLE_CLIENTS_LEAD_WRITE']);
                this.canSearchLeadClients = this.canSearchRegisteredClients || Principal.hasAnyAuthority(['ROLE_CLIENTS_LEAD_SEARCH']);
                this.updateSearchPermission();
                this.setSelected(this.client);
            };

            this.$onChanges = () => {
                this.options = angular.extend({}, defaultOptions, this.options);
                this.updateSearchPermission();
                this.setSelected(this.client);
            }

            this.updateSearchPermission = () => this.canSearchClients = this.allClients ? this.canSearchRegisteredClients : this.canSearchLeadClients;

            this.getClients = ($viewValue) => {
                if (!this.canSearchClients) {
                    return [];
                }
                if(this.allClients)
                    return Client.autocomplete({q: $viewValue}).$promise.then(items => prepareTypeaheadItems(items, this.options))
                else
                    return ClientLead.autocomplete({q: $viewValue}).$promise.then(items => prepareTypeaheadItems(items, this.options))
            }

            this.onTypeheadSelect = ($item, $model, $label, $event) => {
                this.selectClient($model)
            }

            this.selectClient = (client) => {
                this.setSelected(client);
                this.onSelect({
                    value: client
                })
            }

            this.setSelected = client => {
                this.selected = client;
                this.selectedContacts = this.sortedContacts(client);
                this.selectedManagers = sortManagers(client && client.managerUsers);
            }

            this.onDeselect = () => {
                this.search = null;
                this.selectClient(null);
            }

            this.hasClientPreview = () => {
                return !!this.getSelectedClientId();
            }

            this.openClientPreview = () => {
                const clientId = this.getSelectedClientId();
                if (!clientId || !this.isMainClient() || !this.canOpenClientModule) {
                    return;
                }
                $state.go('clientShow', {id: clientId});
            }

            this.openCompactPreview = () => {
                if (!this.selected || !this.canReadSelectedClient()) {
                    return;
                }
                return ClientFinderService.preview(this.selected);
            }

            this.addClientLead = () => {
                if (this.allClients) {
                    if (!this.canWriteClients) {
                        return;
                    }
                    ClientService.addModal().then(client => this.selectClient(mapClientToClientLead(client)));
                    return;
                }
                if (!this.canWriteLeadClients) {
                    return;
                }
                return ClientFinderService.edit(null).then((client) => this.selectClient(client));
            }

            this.canAddClient = () => this.allClients ? this.canWriteClients : this.canWriteLeadClients;


            this.editClientLead = () => {
                const clientId = this.getSelectedClientId();
                if (!clientId || !this.canWriteClients) {
                    return;
                }
                ClientService.edit(clientId).then(client => this.selectClient(mapClientToClientLead(client)))
            }

            this.isLeadOnly = () => {
                return !!(this.selected && this.selected.leadOnly === true);
            }

            this.isMainClient = () => {
                return !!(this.selected && this.selected.leadOnly !== true);
            }

            this.editLeadOnly = () => {
                const clientId = this.getSelectedClientId();
                if (!clientId || this.selected.leadOnly !== true || !this.canWriteLeadClients) {
                    return;
                }
                ClientLead.get({id: clientId}).$promise
                    .then(client => ClientFinderService.edit(client))
                    .then(client => this.selectClient(client));
            }

            this.canReadSelectedClient = () => this.isLeadOnly() ? this.canReadLeadClients : this.canReadClients;

            this.canWriteSelectedClient = () => this.isLeadOnly() ? this.canWriteLeadClients : this.canWriteClients;

            this.hasClientActions = () => this.hasClientPreview() && ((this.isMainClient() && this.canOpenClientModule) || this.canReadSelectedClient() || this.canWriteSelectedClient());

            this.getSelectedClientId = () => {
                if (!this.selected) {
                    return null;
                }
                return this.selected.id || this.selected.clientId || null;
            }

            this.getFirstContactValue = client => {
                const contact = getClientContacts(client).find(item => item && item.value);
                return contact ? contact.value : null;
            }

            this.sortedContacts = client => sortContacts(getClientContacts(client))
                .filter(contact => isContactVisible(contact, this.options));

            function mapClientToClientLead(client) {
                return {
                    id: client.id,
                    symbol: client.symbol,
                    fullName: client.fullName,
                    contacts: client.contacts || [],
                    leadOnly: client.leadOnly,
                    type: client.type,
                    nip: client.nip,
                    address: client.address,
                    postcode: client.postcode,
                    city: client.city
                }
            }

            function getClientContacts(client) {
                const contacts = ((client && client.contacts) || []).slice();
                addFlatContact(contacts, 'PHONE', client && client.phone1);
                addFlatContact(contacts, 'PHONE', client && client.phone2);
                addFlatContact(contacts, 'EMAIL', client && client.email);
                return contacts;
            }

            function addFlatContact(contacts, type, value) {
                if (!value) {
                    return;
                }
                const exists = contacts.some(contact => contact && contact.type === type && contact.value === value);
                if (!exists) {
                    contacts.push({type: type, value: value, active: true});
                }
            }

            function prepareTypeaheadItems(items, options) {
                return (items || []).map(item => {
                    item.finderContacts = sortContacts(getClientContacts(item))
                        .filter(contact => isContactVisible(contact, options));
                    return item;
                });
            }

            function sortContacts(contacts) {
                const order = {PHONE: 1, EMAIL: 2, WEBSITE: 3, OTHER: 4};
                return (contacts || []).slice().sort((a, b) => {
                    const typeCompare = (order[a.type] || 9) - (order[b.type] || 9);
                    if (typeCompare !== 0) {
                        return typeCompare;
                    }
                    return (a.id || 0) - (b.id || 0);
                });
            }

            function sortManagers(managers) {
                return (managers || []).slice().sort((a, b) => {
                    const lastNameCompare = (a.lastName || '').localeCompare(b.lastName || '');
                    if (lastNameCompare !== 0) {
                        return lastNameCompare;
                    }
                    return (a.fullName || '').localeCompare(b.fullName || '');
                });
            }

            function isContactVisible(contact, options) {
                if (!contact || !contact.value) {
                    return false;
                }
                if (contact.type === 'PHONE') {
                    return options.showPhone !== false;
                }
                if (contact.type === 'EMAIL') {
                    return options.showEmail !== false;
                }
                return true;
            }
        },
    })
    .controller('ClientFinderPreviewController', function (Client, ClientLead, data, $uibModalInstance, $q) {
        this.$onInit = () => {
            this.item = data;
            this.isLoading = true;
            this.loadClient(data)
                .then(client => this.item = client)
                .finally(() => this.isLoading = false);
        };

        this.close = () => $uibModalInstance.dismiss('Canceled');

        this.loadClient = client => {
            const clientId = client && (client.id || client.clientId);
            if (!clientId) {
                return $q.when(client);
            }
            if (client.leadOnly === true) {
                return ClientLead.get({id: clientId}).$promise;
            }
            return Client.get({id: clientId}).$promise;
        };
    })
    .controller('ClientFinderDialogController', function ($rootScope, $timeout, toastr, ClientLead, Principal, GusService, data, $uibModalInstance) {
        let onSaveSuccess = function (result) {
            $rootScope.$broadcast('client.updated');
            $uibModalInstance.close(result);
        };
        this.$onInit = () => {
            let modalData = data && angular.isDefined(data.client) ? data : {client: data, options: {}}
            this.options = modalData.options || {}
            this.item = modalData.client || {
                type: 'RETAIL'
            }
            this.item.contacts = this.item.contacts || []
            if (angular.isFunction(this.options.beforeOpen)) {
                this.options.beforeOpen(this.item)
            }
            this.sourceSync = prepareSourceSync(this.options.sourceSync, this.item)
            if(this.item.id == null){
                Principal.currentUser().then(user => {
                    this.item.managerUsers = [user];
                });
            }
        }

        this.cancel = () => $uibModalInstance.dismiss('Canceled');
        this.useClientName = () => {
            if (!this.sourceSync) {
                return
            }
            this.sourceSync.nameChoice = 'CLIENT'
            this.item.fullName = this.sourceSync.clientName
        }
        this.useSourceName = () => {
            if (!this.sourceSync) {
                return
            }
            this.sourceSync.nameChoice = 'SOURCE'
            this.item.fullName = this.sourceSync.sourceName
        }
        this.save = function () {
            this.item.contacts = normalizeContacts(this.item.contacts)
            if (this.item.id) {
                return ClientLead.update(this.item, onSaveSuccess, () => {});
            } else {
                return ClientLead.save(this.item, onSaveSuccess, () => {});
            }
        };

        this.gusUpdate = () => {
            this.isProcessing = true
            GusService.search(this.item.nip)
                .then(gus => {
                        this.isProcessing = false
                        toastr.success("Załadowano dane z: " + gus.details.nazwa)
                        this.item.nip = gus.nip
                        this.item.fullName = gus.details.nazwa
                        this.item.address = gus.details.adres
                        this.item.postcode = gus.details.kodPocztowy
                        this.item.city = gus.details.miasto
                        addContactIfMissing(this.item, 'PHONE', gus.details.numerTelefonu, 'Telefon z GUS')
                        addContactIfMissing(this.item, 'EMAIL', gus.details.email, 'Email z GUS')
                        addContactIfMissing(this.item, 'WEBSITE', gus.details.stronaInternetowa, 'WWW z GUS')
                    },
                    () => $ctrl.isProcessing = false)
        }
        this.onTypeChanged = type => {
            if(type !== 'COMPANY') {
                this.item.nip = null
            }
        }
        this.onDefaultContactChange = contact => {
            this.item.contacts.filter(v => v !== contact).forEach(value => value.defaults = false)
        }
        this.addContact = () => {
            this.item.contacts.push({active: true, defaults: false, type: 'OTHER'})
            const index = this.item.contacts.length - 1
            $timeout(() => {
                const element = document.getElementById(`lead-client-contact-value-text-${index}`)
                    || document.getElementById(`lead-client-contact-value-email-${index}`)
                    || document.getElementById(`lead-client-contact-value-phone-${index}`)
                if (element && angular.isFunction(element.focus)) {
                    element.focus()
                    if (angular.isFunction(element.select)) {
                        element.select()
                    }
                }
            })
        }
        this.removeContact = contact => {
            const index = this.item.contacts.indexOf(contact)
            if (index >= 0) {
                this.item.contacts.splice(index, 1)
            }
        }
        this.inferContactTypeOnBlur = contact => {
            if (!contact || normalizeContactType(contact.type) !== 'OTHER') {
                return
            }
            contact.type = detectContactType(contact.value)
        }

        function normalizeText(value) {
            return typeof value === 'string' ? value.trim() : ''
        }

        function prepareSourceSync(sourceSync, client) {
            if (!sourceSync || !sourceSync.nameDifferent) {
                return null
            }
            const sourceName = normalizeText(sourceSync.sourceName)
            const clientName = normalizeText(sourceSync.clientName || client.fullName)
            if (!sourceName || !clientName || normalizeName(sourceName) === normalizeName(clientName)) {
                return null
            }
            return {
                sourceName: sourceName,
                clientName: clientName,
                nameChoice: normalizeName(client.fullName) === normalizeName(sourceName) ? 'SOURCE' : 'CLIENT'
            }
        }

        function normalizeName(value) {
            return normalizeText(value).replace(/\s+/g, ' ').toLowerCase()
        }

        function normalizeContactType(value) {
            const normalized = normalizeText(value).toUpperCase()
            return ['PHONE', 'EMAIL', 'WEBSITE', 'OTHER'].includes(normalized) ? normalized : 'OTHER'
        }

        function detectContactType(rawValue) {
            const value = normalizeText(rawValue)
            if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
                return 'EMAIL'
            }
            if (value.indexOf('http://') === 0 || value.indexOf('https://') === 0 || /^www\./i.test(value)) {
                return 'WEBSITE'
            }
            const digits = value.replace(/\D/g, '')
            return digits.length >= 7 ? 'PHONE' : 'OTHER'
        }

        function normalizeContactValue(value, type) {
            value = normalizeText(value)
            if (type === 'EMAIL') {
                return value.toLowerCase()
            }
            if (type === 'PHONE' || type === 'WEBSITE') {
                return value.replace(/\s/g, '')
            }
            return value
        }

        function addContactIfMissing(client, type, value, name) {
            value = normalizeText(value)
            if (!value) {
                return
            }
            client.contacts = client.contacts || []
            const normalizedValue = normalizeContactValue(value, type)
            const exists = client.contacts.some(contact => contact && contact.type === type && normalizeContactValue(contact.value, type) === normalizedValue)
            if (!exists) {
                client.contacts.push({active: true, defaults: false, type: type, value: value, name: name})
            }
        }

        function normalizeContacts(contacts) {
            const normalized = []
            ;(contacts || []).forEach(contact => {
                const base = angular.copy(contact || {})
                const name = normalizeText(base.name)
                const type = normalizeContactType(base.type || detectContactType(base.value))
                const value = normalizeContactValue(base.value, type)
                if (!name && !value) {
                    return
                }
                base.name = name || null
                base.value = value || null
                base.type = type
                normalized.push(base)
            })

            let defaultAssigned = false
            normalized.forEach(contact => {
                if (contact.defaults && !defaultAssigned) {
                    defaultAssigned = true
                    return
                }
                contact.defaults = false
            })
            return normalized
        }
    })
